import { useStyles } from '../../../styles';

interface WorkItemsTableProps {
  items: string[];
}

const parseLinkForItemNumber = (link: string): string => {
  return link.split('/').pop() ?? '';
};

export function WorkItemsTable({ items }: WorkItemsTableProps) {
  const classes = useStyles();

  if (!items || items.length === 0) {
    return (
      <p className={`text-sm italic ${classes.noWorkItemsMessage}`}>
        No work items to display.
      </p>
    );
  }

  return (
    <table
      className={`w-full text-sm border-collapse border rounded ${classes.workItemsTable}`}
    >
      <thead>
        <tr className={classes.workItemsTableHeadRow}>
          <th
            className={`text-left px-4 py-3 font-medium text-sm whitespace-nowrap border-b w-[110px] ${classes.workItemsTableHeadCell}`}
          >
            Work Item ID
          </th>
          <th
            className={`text-left px-4 py-3 font-medium text-sm border-b ${classes.workItemsTableHeadCell}`}
          >
            Work item Link
          </th>
        </tr>
      </thead>
      <tbody>
        {items.map((link: string) => {
          const itemNumber = parseLinkForItemNumber(link);
          return (
            <tr
              key={itemNumber}
              className={`border-b transition-colors ${classes.workItemsTableBodyRow}`}
            >
              <td className="px-4 py-3 text-sm whitespace-nowrap">
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`underline hover:opacity-80 transition-opacity ${classes.workItemsTableLink}`}
                >
                  {itemNumber}
                </a>
              </td>
              <td className="px-4 py-3 text-sm max-w-xs truncate">
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`underline hover:opacity-80 transition-opacity ${classes.workItemsTableLink}`}
                  title={link}
                >
                  {link}
                </a>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
